const DiscountProductData =[
    {
        discountProductTitle:'Load Scale',
        discountProductPrice:'35,500.00',
        discountProductImage:'../product-category-image/loader-scale-cate.png',
    },
    {
        discountProductTitle:'Weight Machine',
        discountProductPrice:'75,500.00',
        discountProductImage:'../product-category-image/Weight-Scales.png',
    },
    {
        discountProductTitle:'Grass Cutter',
        discountProductPrice:'4,500.00',
        discountProductImage:'../product-category-image/grass-cutters.png',
    },
    {
        discountProductTitle:'Room Hitter',
        discountProductPrice:'10,500.00',
        discountProductImage:'../product-category-image/room-hitters.png',
    },
    {
        discountProductTitle:'LED-Light',
        discountProductPrice:'5,000.00',
        discountProductImage:'../product-category-image/tube-lights.png',
    },
    {
        discountProductTitle:'Sprea Machine',
        discountProductPrice:'15,500.00',
        discountProductImage:'../product-category-image/sprayer-Machines-02.png',
    }
    ,
    {
        discountProductTitle:'Animal Mattress',
        discountProductPrice:'18,000.00',
        discountProductImage:'../product-category-image/mattress.png',
    },
    {
        discountProductTitle:'Milk Detector',
        discountProductPrice:'25,000.00',
        discountProductImage:'../product-category-image/milk-detector.png',
    }
]
export default DiscountProductData;